<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
  >
    <g id="Group_1005" data-name="Group 1005">
      <path
        id="Path_396"
        data-name="Path 396"
        d="M17.028,14.457l-1.585,2.079a.894.894,0,0,0,.212,1.286.993.993,0,0,0,.567.176A.979.979,0,0,0,17,17.62l1.6-2.1a7.735,7.735,0,0,0,3.516.838,7.344,7.344,0,0,0,7.5-7.159,6.985,6.985,0,0,0-2.28-5.134l1.989-2.608A.894.894,0,0,0,29.112.175a.994.994,0,0,0-1.347.2L25.79,2.966a7.726,7.726,0,0,0-3.675-.922,7.344,7.344,0,0,0-7.5,7.159A7,7,0,0,0,17.028,14.457ZM27.686,9.2a5.455,5.455,0,0,1-5.571,5.318,5.751,5.751,0,0,1-2.362-.509L26.182,5.58A5.165,5.165,0,0,1,27.686,9.2ZM22.115,3.885a5.743,5.743,0,0,1,2.528.585l-6.471,8.486A5.183,5.183,0,0,1,16.543,9.2,5.456,5.456,0,0,1,22.115,3.885Z"
        transform="translate(-14.615 0.001)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "discon-icon",
};
</script>

<style scoped></style>
